export const ENABLE_MAINTENANCE_MODE = "ENABLE_MAINTENANCE_MODE";
export const MAINTENANCE_MODE_MESSAGE = "under maintenance";
export const MAINTENANCE_BYPASS_TOKEN_COOKIE = "maintenance_bypass_token";
export const MAINTENANCE_BYPASS_TOKEN_QUERY_PARAM = "token";
